import { UspItem } from '../../entities/@blocks/UspSection/UspSection';

export const MOCK_USPS: UspItem[] = [
    { id: 0, text: 'Online besteld? Gratis verzonden', icon: 'cart-truck' },
    { id: 1, text: 'Keuze uit meer dan 300 meubelmerken', icon: 'lamp' },
    { id: 2, text: 'Niet tevreden? Geld terug!', icon: 'happy' },
];
